import { Box, SelectChangeEvent, useTheme } from '@mui/material';
import { PoolSelect } from '@synergy/components-next';
import { ReactElement } from 'react';
import { SelectOption } from '@synergy/components';

import { ATTRIBUTE_NO_VALUE } from '../../../models/constants/attribute-no-value';
import { AttributeOption } from '../../../store/articles-variants-selector';
import { useArticleDetailContext } from '../article-detail';

export interface ArticleDetailVariantsAttributeProps {
    attribute: AttributeOption;
}

export const ArticleDetailVariantsAttribute = (props: ArticleDetailVariantsAttributeProps): ReactElement => {
    const { attribute } = props;
    const { article, onVariantSelected } = useArticleDetailContext();
    const theme = useTheme();

    const handleSelectChange =
        (values: { value: string; variantId: number }[]) => (event: SelectChangeEvent<string | '' | null>) => {
            const variantId = values.find(value => value.value === event.target.value)?.variantId;
            if (variantId === undefined) {
                return;
            }
            onVariantSelected(variantId);
        };

    return (
        <PoolSelect
            key={attribute.attributeId}
            fullWidth={true}
            options={attribute.options.map<SelectOption>(value => ({
                value: value.value,
                displayValue: (
                    <Box
                        sx={{
                            color: value.isFullMatch ? undefined : theme.palette.text.disabled,
                        }}
                    >
                        {value.value}
                    </Box>
                ),
            }))}
            value={
                article.attributes.find(att => att.attributeId === attribute.attributeId)?.value || ATTRIBUTE_NO_VALUE
            }
            label={attribute.name}
            onChange={handleSelectChange(attribute.options)}
        />
    );
};
